'use client';

function isBodyElement(element) {
    return element === document.body;
}

export { isBodyElement as default };
//# sourceMappingURL=isBodyElement.js.map
